import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useState } from "react";
import { Form, Input, Button, Alert, Typography, Card, Flex, App, theme } from "antd";
import { supabase } from "@/configs/supabase/config";

export const Route = createFileRoute("/_auth/reset-password")({
  component: Page_ResetPassword,
});

function Page_ResetPassword() {
  const { token } = theme.useToken();
  const { message } = App.useApp();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (values: { email: string }) => {
    setError(null);
    setLoading(true);

    const sb_Auth_ResetPassword = await supabase.auth.resetPasswordForEmail(values.email, {
      redirectTo: `${window.location.origin}/update-password`,
    });

    setLoading(false);

    if (sb_Auth_ResetPassword.error) {
      setError(sb_Auth_ResetPassword.error.message);
      message.error("Failed to send reset email");
      return;
    }

    setSubmitted(true);
  };

  return (
    <Card style={{ width: 400 }} styles={{ body: { padding: token.paddingXL } }}>
      <Flex vertical align="center" gap={token.marginMD}>
        <Typography.Title level={3} style={{ margin: 0 }}>
          Reset Password
        </Typography.Title>
      </Flex>

      {error && (
        <Alert
          message={error}
          type="error"
          showIcon
          closable
          onClose={() => setError(null)}
          style={{ marginTop: token.marginMD }}
        />
      )}

      {submitted ? (
        <Flex vertical gap={token.marginMD} style={{ marginTop: token.marginLG }}>
          <Alert
            message="Reset link sent"
            description="Check your inbox for the password reset link."
            type="success"
            showIcon
          />
          <Flex justify="center">
            <Button type="link" onClick={() => navigate({ to: "/login" })}>
              Back to login
            </Button>
          </Flex>
        </Flex>
      ) : (
        <>
          <Typography.Paragraph type="secondary" style={{ textAlign: "center", marginTop: token.marginMD }}>
            Enter your email and we'll send you a reset link.
          </Typography.Paragraph>

          <Form layout="vertical" onFinish={handleSubmit} autoComplete="on" style={{ marginTop: token.marginMD }}>
            <Form.Item
              name="email"
              label="Email"
              rules={[
                { required: true, message: "Email is required" },
                { type: "email", message: "Enter a valid email" },
              ]}
            >
              <Input size="large" placeholder="you@company.com" autoFocus />
            </Form.Item>

            <Form.Item style={{ marginBottom: token.marginXS }}>
              <Button type="primary" htmlType="submit" size="large" block loading={loading}>
                Send reset link
              </Button>
            </Form.Item>
          </Form>

          <Flex justify="center" style={{ marginTop: token.marginSM }}>
            <Button type="link" size="small" onClick={() => navigate({ to: "/login" })}>
              Back to login
            </Button>
          </Flex>
        </>
      )}
    </Card>
  );
}
